import apiFetch from '../apiFetch'

export default function (documentId, sheetId, token, lastAccessDate) {
  return apiFetch({ endPoint: `document/${documentId}/sheet/${sheetId}`, method: 'DELETE', body: null, token: token, lastAccessDate })
}
